import {
  DatePicker
} from "./2JYOWXI7.jsx";
import {
  getDecimalPlaces
} from "./ARBBQ34R.jsx";
import {
  LabeledGroup
} from "./TQPZEPSZ.jsx";
import {
  SearchSelect,
  Select
} from "./AWY7PNYH.jsx";
import {
  Tooltip_default
} from "./YUSNKVRT.jsx";
import {
  RingLoader
} from "./GCJBVBMR.jsx";
import {
  cn
} from "./O62HZC57.jsx";
import {
  useLocalization
} from "./E42DI7CC.jsx";

// src/Inputs/Checkbox.tsx
import { createMemo, splitProps, Show } from "solid-js";

// src/Inputs/filledCheck.svg
import { mergeProps } from "solid-js";
var SvgComponent = (userProps) => {
  const defaultProps = {
    "width": "10",
    "height": "8",
    "viewBox": "0 0 10 8",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  const props = mergeProps(defaultProps, userProps);
  return <svg {...props} innerHTML={` <path d="M9.40439 0.941382C9.13408 0.671069 8.696 0.671069 8.42568 0.941382L3.77666 5.59041L1.57451 3.38826C1.3042 3.11794 0.866113 3.11794 0.595801 3.38826C0.325488 3.65857 0.325488 4.09666 0.595801 4.36697L3.2874 7.05857C3.55771 7.32888 3.9958 7.32888 4.26611 7.05857L9.40439 1.92009C9.67471 1.64998 9.67471 1.21169 9.40439 0.941382Z" fill="currentColor"/> `} />;
};
var FilledCheck_default = SvgComponent;

// src/Inputs/Checkbox.tsx
import { v4 as uuidv4 } from "uuid";
var Checkbox = (props) => {
  const id = createMemo(() => props.id || uuidv4());
  const [localProps, inputProps] = splitProps(props, ["id", "label", "class", "htmlType", "labelPosition", "color"]);
  return <div class={cn("inline-flex shrink-0 select-none items-center gap-2 overflow-hidden", props.checkBoxClass)}>
      <Show when={localProps.labelPosition === "left"}>
        <Show when={props.showLabel && props.label}>
          <label
    for={id()}
    class={cn("cursor-pointer truncate", { "cursor-not-allowed": props.disabled }, props.labelClass)}
    style={props.labelStyle}
  >
            {props.label}
          </label>
        </Show>
      </Show>
      <label class="relative flex items-center" for={id()} data-ripple-dark="true">
        <input
    type={localProps.htmlType || "checkbox"}
    class={cn(
      "before:content[''] border-blue-gray-200 before:bg-blue-gray-500 checked:border-essential-colour checked:bg-essential-colour hover-allowed:hover:before:opacity-10 peer relative size-5 cursor-pointer appearance-none rounded-md border transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:size-12 before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-full before:opacity-0 before:transition-opacity",
      { "rounded-full checked:bg-white": props.htmlType === "radio" },
      { "cursor-not-allowed": props.disabled },
      {
        "border-input-border bg-input-border checked:border-input-border checked:bg-input-border": props.disabled
      },
      {
        "checked:border-input-border checked:bg-[#09BE09]": localProps.color === "green"
      },
      props.class
    )}
    id={id()}
    {...inputProps}
    onInput={(ev) => props.onInput?.(ev.target.checked)}
  />
        <Show
    when={props.htmlType === "radio"}
    fallback={<div class="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100">
              <FilledCheck_default aria-label="Filled check" />
            </div>}
  >
          <i class="bg-essential-colour pointer-events-none absolute left-2/4 top-2/4 size-2 -translate-x-2/4 -translate-y-2/4 rounded-full opacity-0 peer-checked:opacity-100" />
        </Show>
      </label>
      <Show when={localProps.labelPosition !== "left"}>
        <Show when={props.showLabel && props.label}>
          <label
    for={id()}
    class={cn(
      "cursor-pointer truncate",
      { "order-1 ml-0 mr-4": localProps.labelPosition === "left" },
      { "cursor-not-allowed": props.disabled },
      props.labelClass
    )}
    style={props.labelStyle}
  >
            {props.label}
          </label>
        </Show>
      </Show>
    </div>;
};

// src/Inputs/LabeledSelect.tsx
var LabeledSelect = (props) => {
  const handleChange = (value) => {
    props.onInput && props.onInput(value);
  };
  return <LabeledGroup {...props} labelClass={props.labelClass}>
      <Select
    id={props.id}
    prefix={props.prefix}
    class={props.selectClass}
    value={props.value}
    onChange={handleChange}
    options={props.options}
    multiple={props.multiple}
    placeholder={props.placeholder}
    disabled={props.disabled}
    emptyDescription={props.emptyDescription}
    disabledTooltip={props.disabledTooltip}
  />
    </LabeledGroup>;
};

// src/Inputs/LabeledNumberInput.tsx
import Decimal from "decimal.js";
import { Show as Show2 } from "solid-js";
var LabeledNumberInput = (props) => {
  const externalValueToInput = (value) => {
    try {
      const _value = new Decimal(value);
      return props.percent ? _value.mul(100).toString() : _value.toString();
    } catch {
      return "";
    }
  };
  const getParsedValueFromInput = (inputElement) => {
    const inputValue = inputElement.value.trim();
    if (inputValue === "") {
      return void 0;
    }
    try {
      let inputDecimal = new Decimal(inputValue);
      if (props.percent) {
        inputDecimal = inputDecimal.div(100);
      }
      return inputDecimal.toNumber();
    } catch (error) {
      return void 0;
    }
  };
  const handleChange = (e) => {
    const parsedValue = getParsedValueFromInput(e.target);
    props.onInput?.(parsedValue);
  };
  return <LabeledGroup {...props} error={props.error}>
      <div
    class={cn(
      "bg-inputbox-bg focus-within:ring-essential-colour flex w-full items-center rounded-md border focus-within:ring-1",
      props.inputContainerClass
    )}
  >
        <Show2 when={props.prepend}>
          <span class="text-text-level03 flex items-center border-r border-[#5551] px-3">{props.prepend}</span>
        </Show2>
        <Tooltip_default message={props.disabledTooltip} disabled={!props.disabled || !props.disabledTooltip} class="w-full" align="bottom">
          <input
    id={props.id}
    min={props.min}
    max={props.max}
    class={cn(
      "bg-inputbox-bg placeholder:text-auxiliary-text w-full rounded-md border border-transparent px-3 py-2 text-sm text-black outline-none",
      { "rounded-r-none": !!props.suffix },
      props.inputClass
    )}
    value={externalValueToInput(props.value)}
    onChange={handleChange}
    type="number"
    placeholder={props.placeholder}
    step={props.step ?? 0.01}
    disabled={props.disabled}
  />
        </Tooltip_default>

        <Show2 when={props.suffix}>
          <div class={cn("bg-inputbox-bg text-text-level03 mr-2 w-10 text-center", props.suffixClass)}>{props.suffix}</div>
        </Show2>
      </div>
    </LabeledGroup>;
};

// src/Inputs/LabeledTextInput.tsx
import { Show as Show3, createEffect, createMemo as createMemo2, createSignal, mergeProps as mergeProps2 } from "solid-js";
var defaultTriggerName = "onChange";
var LabeledTextInput = (rawProps) => {
  const props = mergeProps2(
    {
      max: rawProps.type === "number" ? rawProps.max ? 1e9 : void 0 : void 0
    },
    rawProps
  );
  const [value, setValue] = createSignal();
  const [isTouched, setTouched] = createSignal(false);
  const [setError] = createSignal(void 0);
  let inputRef;
  const isInvalid = createMemo2(() => !!props.error);
  const errorMessage = createMemo2(() => {
    if (!isTouched() || !props.validationFunction) return void 0;
    return handleInputValidation(props.value, props.validationFunction, setError) || props.error;
  });
  const onChangeMethodName = () => props?.eventTriggerName ?? defaultTriggerName;
  const cleanInvisibleCharacters = (str) => {
    return str.replace(/[\u200B-\u200D\uFEFF]/g, "").replace(/[\u200E\u200F\u202A-\u202E]/g, "").replace(/[\u2060-\u2064]/g, "").replace(/[\u00A0\u1680\u180E\u2000-\u200A\u202F\u205F\u3000]/g, " ").trim();
  };
  const handleInput = (value2, event) => {
    const trimmedValue = cleanInvisibleCharacters(value2);
    props.onInput && props.onInput(props.percent ? (+trimmedValue / 100).toFixed(getDecimalPlaces(trimmedValue) + 2) : trimmedValue, event);
    setTouched(true);
  };
  const handleBlur = () => setTouched(true);
  createEffect(() => {
    if (props.percent && props.value) {
      const dpFixed = getDecimalPlaces(props.value) < 2 ? 0 : getDecimalPlaces(props.value) - 2;
      setValue((100 * props.value).toFixed(dpFixed));
    } else {
      setValue(props.value ?? "");
      if (!props.value && inputRef) {
        inputRef.value = "";
      }
    }
  });
  return <LabeledGroup {...props} error={errorMessage()} labelClass={props.labelClass}>
      <div
    class={cn(
      "bg-inputbox-bg focus-within:ring-essential-colour flex w-full flex-1 overflow-hidden rounded-md border transition focus-within:ring-1",
      props.inputContainerClass
    )}
    classList={{
      "border-red-300": isInvalid(),
      "ring-0": isInvalid()
    }}
  >
        <Show3 when={props.prepend}>
          <span class="text-text-level03 flex items-center border-r border-[#5551] px-3">{props.prepend}</span>
        </Show3>
        <input
    id={props.id}
    ref={inputRef}
    max={props.max}
    maxlength={props.maxlength}
    class={cn(
      "placeholder:text-auxiliary-text w-full flex-1 bg-transparent px-3 py-2 text-sm text-black outline-none",
      { "cursor-not-allowed": props.disabled },
      props.inputClass
    )}
    value={value()}
    required={props.required}
    {...{
      [onChangeMethodName()]: (e) => {
        handleInput(e.target.value, e);
      }
    }}
    step="any"
    disabled={props.disabled}
    onBlur={handleBlur}
    type={props.type || "text"}
    placeholder={props.placeholder}
    onMouseDown={() => props.onClick && props.onClick(true)}
    onMouseUp={() => props.onClick && props.onClick(false)}
    onKeyDown={(e) => props.onKeyDown?.(e)}
  />
        <Show3 when={props.suffix}>
          <span class="text-text-level03 flex items-center border-l border-[#5551] px-3">{props.suffix}</span>
        </Show3>
      </div>
    </LabeledGroup>;
};
var handleInputValidation = (value, validationFunction, setErrorFunction) => {
  const errorMessage = validationFunction(value || "");
  setErrorFunction(errorMessage);
  return errorMessage;
};

// src/Inputs/DueDateInputField.tsx
import dayjs from "dayjs";
import { Show as Show4, createSignal as createSignal2 } from "solid-js";
var DueDateInputField = (props) => {
  const { t } = useLocalization();
  const [showDate, setShowDate] = createSignal2(true);
  return <LabeledGroup label={props.label} labelJSX={props.labelJSX} class={props.class} error={props.error} required={props.required}>
      <div class="flex items-center">
        <Show4 when={showDate()}>
          <div class="flex-1">
            <DatePicker
    id={props.id}
    disabled={props.disabled}
    value={props.value ?? void 0}
    onChange={props.onInput}
    placeholder={props.placeholder}
    onMouseDown={() => props.onClick?.(true)}
    onMouseUp={() => props.onClick?.(false)}
    yearRange={props.yearRange}
    disabledDate={props.disabledDate}
    defaultMonth={props.defaultMonth}
  />
          </div>
        </Show4>
        <Show4 when={props.showUntil}>
          <Checkbox
    checkBoxClass="ml-2 h-9 text-xs"
    label={t("Until now")}
    showLabel
    onInput={(checked) => {
      setShowDate(!checked);
      if (!checked) return;
      props.onInput?.(dayjs().format("YYYY-MM-DD"));
    }}
  />
        </Show4>
      </div>
    </LabeledGroup>;
};
var LabeledDateInputField = DueDateInputField;

// src/Inputs/InputSwitch.tsx
import { createEffect as createEffect2, createMemo as createMemo3, createSignal as createSignal3, Show as Show5 } from "solid-js";
var InputSwitch = (props) => {
  const [checked, setChecked] = createSignal3(void 0);
  const [loading, setLoading] = createSignal3(false);
  const values = createMemo3(() => props.values || [true, false]);
  const toggleSwitch = async () => {
    if (props.disabled) {
      return;
    }
    setLoading(true);
    const flag = checked();
    const v = !flag ? values()[0] : values()[1];
    let result;
    if (props.onChange) {
      result = await props.onChange(v);
    }
    setChecked(result ?? v);
    setLoading(false);
  };
  createEffect2(() => {
    setChecked(props.checked);
  });
  return <div
    class="relative flex h-6 w-11 shrink-0 cursor-pointer select-none rounded-full transition-colors"
    classList={{
      "cursor-not-allowed": props.disabled,
      "bg-essential-colour": checked(),
      "bg-[#EDF2F7]": !checked()
    }}
    style={props.style}
    tabIndex="0"
    onClick={toggleSwitch}
  >
      <span
    class="absolute m-0.5 flex size-5 items-center justify-center rounded-full bg-white transition-all"
    classList={{
      "left-0": !checked(),
      "left-5": checked()
    }}
  >
        <Show5 when={loading() && props.enableLoading}>
          <RingLoader size={16} color="#A126EC" />
        </Show5>
      </span>
      <input name={props.name} type="hidden" value={checked() ? values()[0] : values()[1]} />
    </div>;
};
var InputSwitch_default = InputSwitch;

// src/Inputs/LabeledInputSwitch.tsx
var LabeledInputSwitch = (props) => {
  const handleChange = (value) => {
    props.onInput && props.onInput(value);
  };
  return <LabeledGroup {...props} labelClass={props.labelClass}>
      <InputSwitch_default onChange={handleChange} checked={props.value} name={props.name} disabled={props.disabled} style={props.style} />
    </LabeledGroup>;
};

// src/Inputs/LabeledSearchSelect.tsx
import { splitProps as splitProps2 } from "solid-js";
var LabeledSearchSelect = (props) => {
  const [groupProps, searchSelectProps] = splitProps2(props, [
    "label",
    "labelClass",
    "error",
    "labelJSX",
    "labelContainerClass",
    "groupClass",
    "inputContainerClass",
    "description",
    "required",
    "disabled"
  ]);
  return <LabeledGroup {...groupProps}>
      <SearchSelect {...searchSelectProps} />
    </LabeledGroup>;
};

// src/Inputs/LabeledTextArea.tsx
import { createEffect as createEffect3, createMemo as createMemo4, createSignal as createSignal4 } from "solid-js";
import { Dynamic } from "solid-js/web";
var defaultTriggerName2 = "onChange";
var LabeledTextArea = (props) => {
  const [isTouched, setTouched] = createSignal4(false);
  const [setError] = createSignal4(void 0);
  let inputRef;
  const isInvalid = createMemo4(() => !!props.error);
  const errorMessage = createMemo4(() => {
    if (!isTouched() || !props.validationFunction) return void 0;
    return handleInputValidation2(props.value, props.validationFunction, setError);
  });
  const onChangeMethodName = () => props?.eventTriggerName ?? defaultTriggerName2;
  const handleInput = (value) => {
    if (props.disabled) return;
    props.onInput?.(value.trim());
    setTouched(true);
  };
  const handleBlur = () => setTouched(true);
  createEffect3(() => {
    if (!props.value && inputRef) {
      inputRef.value = "";
    }
  });
  return <LabeledGroup {...props} error={errorMessage()}>
      <div
    class="border- bg-inputbox-bg placeholder:text-auxiliary-text focus:ring-essential-colour w-full rounded-md border px-3 py-2 text-sm text-black focus:outline-none focus:ring-1"
    classList={{
      "border-red-300": isInvalid(),
      "ring-0": isInvalid()
    }}
  >
        <textarea
    ref={inputRef}
    class="bg-inputbox-bg w-full focus:outline-none focus:ring-0"
    value={props.value || ""}
    classList={{
      "cursor-not-allowed": props.disabled
    }}
    required={props.required}
    rows={props.rows}
    minlength={props.minlength}
    maxlength={props.maxlength}
    disabled={props.disabled}
    {...{
      [onChangeMethodName()]: (e) => {
        handleInput(e.target.value);
      }
    }}
    onBlur={handleBlur}
    placeholder={props.placeholder}
    onMouseDown={() => {
      if (props.disabled) return;
      return props.onClick && props.onClick(true);
    }}
    onMouseUp={() => {
      if (props.disabled) return;
      return props.onClick && props.onClick(false);
    }}
    readOnly={props.disabled}
  />
        <Dynamic component={props.extraItem} />
      </div>
    </LabeledGroup>;
};
var handleInputValidation2 = (value, validationFunction, setErrorFunction) => {
  if (value) {
    const errorMessage = validationFunction(value);
    setErrorFunction(errorMessage);
    return errorMessage;
  }
};

export {
  Checkbox,
  LabeledSelect,
  LabeledNumberInput,
  LabeledTextInput,
  DueDateInputField,
  LabeledDateInputField,
  LabeledInputSwitch,
  LabeledSearchSelect,
  LabeledTextArea
};
